import styled, { css } from 'styled-components'
import { StyledButton, StyledParagraph } from 'components/shared'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 24px 24px 0;
    background: ${theme.colors.greyLight};
  `}
`

export const TaskList = styled.div`
  position: relative;
`

export const DoneButton = styled(StyledButton)`
  position: absolute;
  right: 0;
  top: 12px;
`

export const EmptyBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 32px 16px;
    color: ${theme.colors.greySemiDark};

    svg {
      margin-bottom: 16px;
    }

    ${StyledParagraph} {
      margin-bottom: 24px;
    }
  `}
`
